import workspaceQuery from '../../queries/customer/CustomerPriceMatrixWorkspaceQuery.graphql';
import instanceQuery from '../../queries/customer/CustomerPriceMatrixQuery.graphql';
import temporaryInstanceQuery from '../../queries/customer/CustomerPriceMatrixTemporaryQuery.graphql';
import defaultQuery from '../../queries/customer/CustomerPriceMatrixDefault.graphql';
import mutationQuery from '../../mutations/customer/CustomerPriceMatrixMutation.graphql';
import temporaryMutationQuery from '../../mutations/customer/CustomerPriceMatrixTemporaryMutation.graphql';
import fragment from '../../fragments/customer/CustomerPriceMatrixFragment.graphql';

import { formActions, workspaceActionsForPermissions } from '../../../actions/customer/CustomerPriceMatrixAction';
import { EntityType } from '../../../@types/entityTypes';

const CustomerPriceMatrix: EntityType = {
  type: 'CustomerPriceMatrix',
  title: 'Customer Price Matrices',
  formUrl: '/Sales/CustomerPricing/CustomerPriceMatrix/Details/',
  formTitle: 'Customer Price Matrices',
  workspaceUrl: '/Sales/CustomerPricing/CustomerPriceMatrix/Workspace/',
  instance: instanceQuery,
  temporaryInstance: temporaryInstanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  temporaryUpdate: temporaryMutationQuery,
  fragment,
  screenReference: 'CUSTOMER_PRICE_MATRICES',
  actions: [...workspaceActionsForPermissions, ...formActions],
};

export default CustomerPriceMatrix;
